// extracted by mini-css-extract-plugin
export default {"dialogActions":"ConfirmationDialog_dialogActions__iJCUH","dialog":"ConfirmationDialog_dialog__ecoba","dialogTitle":"ConfirmationDialog_dialogTitle__+JmLG"};